<template>
    <div>
      <PendingResults></PendingResults>
    </div>
  </template>
  
  <script>
  const PendingResults = defineAsyncComponent(() =>
    import("@/components/cases/LabdaqPendingResults")
  );
  import { defineAsyncComponent } from "vue";
  export default {
    components: {
        PendingResults,
    },
  };
  </script>
  